import { useEffect, useState } from 'react'

import { useActiveOrgId } from '~/hooks/org'

const STORAGE_KEY = (orgId: string) => `splits.showArchivedAccounts.${orgId}`
const SYNC_EVENT = 'splitsShowArchivedChanged'

export const useShowArchivedAccounts = (): [
  boolean,
  (value: boolean) => void,
] => {
  const orgId = useActiveOrgId()

  const storageKey = orgId ? STORAGE_KEY(orgId) : null

  const [showArchived, setShowArchivedState] = useState<boolean>(() => {
    if (!storageKey) return false
    const stored = localStorage.getItem(storageKey)
    if (stored === null) return false
    return stored === 'true'
  })

  const setShowArchived = (value: boolean) => {
    setShowArchivedState(value)
    if (storageKey) {
      localStorage.setItem(storageKey, String(value))
    }
    window.dispatchEvent(new CustomEvent(SYNC_EVENT, { detail: value }))
  }

  useEffect(() => {
    if (!storageKey) return

    const stored = localStorage.getItem(storageKey)
    setShowArchivedState(stored === null ? false : stored === 'true')

    const handleSync = (e: CustomEvent<boolean>) => {
      setShowArchivedState(e.detail)
    }

    window.addEventListener(SYNC_EVENT, handleSync as EventListener)
    return () => {
      window.removeEventListener(SYNC_EVENT, handleSync as EventListener)
    }
  }, [storageKey])

  return [showArchived, setShowArchived]
}
